var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvestmentCompare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 268,
    height: 250,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h63v4H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h225v55H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h225v56H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 268,
    height: 260,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Investment compare"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1204"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 46",
    transform: "translate(-282 -1236)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(282 1236)",
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 8",
    fill: "#f2f3f4",
    stroke: "#e6e8e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 14h228a8 8 0 0 1 8 8v228H12V22a8 8 0 0 1 8-8Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 14.5h228a7.5 7.5 0 0 1 7.5 7.5v227.5h-243V22a7.5 7.5 0 0 1 7.5-7.5Z",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 9",
    fill: "#f7f7f7",
    stroke: "#e6e8e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302 1250h228a8 8 0 0 1 8 8v16H294v-16a8 8 0 0 1 8-8Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302 1250.5h228a7.5 7.5 0 0 1 7.5 7.5v15.5h-243V1258a7.5 7.5 0 0 1 7.5-7.5Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 37",
    transform: "translate(304 1259)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 5",
    cx: 3,
    cy: 3,
    r: 3,
    fill: "#ff5552"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 6",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(8)",
    fill: "#ffb53d"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 7",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(16)",
    fill: "#00c243"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 10",
    fill: "#fff",
    stroke: "#e6e8e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M294 1273h244v20H294z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M294.5 1273.5h243v19h-243z"
  })), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 8",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(304 1278)",
    fill: "#9098a4"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Repeat Grid 1",
    transform: "translate(464 1281)",
    opacity: 0.5,
    clipPath: "url(#b)",
    fill: "#9098a4"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(16)"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(32)"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(48)"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Repeat Grid 8",
    transform: "translate(22 63)",
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1205"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1499",
    fill: "#fff",
    d: "M0 0h74v55H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 52",
    transform: "translate(9 10)",
    fill: "#9098a4"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 23",
    width: 20,
    height: 4,
    rx: 1,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 57,
    height: 4,
    rx: 1,
    transform: "translate(0 8)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 54,
    height: 4,
    rx: 1,
    transform: "translate(0 15)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 54,
    height: 4,
    rx: 1,
    transform: "translate(0 22)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 38,
    height: 4,
    rx: 1,
    transform: "translate(0 29)",
    opacity: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1205"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1499",
    fill: "#fff",
    d: "M76 0h74v55H76z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 52",
    transform: "translate(85 10)",
    fill: "#9098a4"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 23",
    width: 20,
    height: 4,
    rx: 1,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 57,
    height: 4,
    rx: 1,
    transform: "translate(0 8)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 54,
    height: 4,
    rx: 1,
    transform: "translate(0 15)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 54,
    height: 4,
    rx: 1,
    transform: "translate(0 22)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 38,
    height: 4,
    rx: 1,
    transform: "translate(0 29)",
    opacity: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1205"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1499",
    fill: "#fff",
    d: "M152 0h74v55h-74z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 52",
    transform: "translate(161 10)",
    fill: "#9098a4"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 23",
    width: 20,
    height: 4,
    rx: 1,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 57,
    height: 4,
    rx: 1,
    transform: "translate(0 8)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 54,
    height: 4,
    rx: 1,
    transform: "translate(0 15)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 54,
    height: 4,
    rx: 1,
    transform: "translate(0 22)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 38,
    height: 4,
    rx: 1,
    transform: "translate(0 29)",
    opacity: 0.5
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1211"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1500",
    fill: "#fff",
    d: "M22 119h225v71H22z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1210",
    fill: "#fd0826"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Ring Chart1"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 136",
    d: "M59.503 132.227a21.5 21.5 0 0 1 18.618 10.749 21.5 21.5 0 0 1 0 21.5l-3.75-2.165a17.167 17.167 0 0 0 0-17.167 17.167 17.167 0 0 0-14.868-8.586Z",
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 137",
    d: "M78.12 164.474a21.5 21.5 0 0 1-27.945 8.62l1.879-3.9a17.167 17.167 0 0 0 22.316-6.885Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 138",
    d: "M50.175 173.094a21.5 21.5 0 0 1-10.684-27.223l4.031 1.582a17.167 17.167 0 0 0 8.532 21.739Z",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 139",
    d: "M39.486 145.871a21.5 21.5 0 0 1 20.016-13.644v4.331a17.167 17.167 0 0 0-15.981 10.9Z",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ring Chart1"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 136",
    d: "M155.118 158.997a21.503 21.503 0 0 1-15.205 15.201 21.503 21.503 0 0 1-20.77-5.568l3.063-3.062a17.169 17.169 0 0 0 16.584 4.446 17.169 17.169 0 0 0 12.145-12.138Z",
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 137",
    d: "M119.146 168.63a21.503 21.503 0 0 1-1.09-29.228l3.282 2.825a17.169 17.169 0 0 0 .87 23.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 138",
    d: "M118.057 139.402a21.503 21.503 0 0 1 29.064-3.27l-2.572 3.484a17.169 17.169 0 0 0-23.21 2.612Z",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 139",
    d: "M147.123 136.127a21.503 21.503 0 0 1 7.996 22.87l-4.184-1.122a17.169 17.169 0 0 0-6.39-18.261Z",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ring Chart1"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 136",
    d: "M188.882 148.456a21.503 21.503 0 0 1 15.205-15.201 21.503 21.503 0 0 1 20.77 5.568l-3.063 3.062a17.169 17.169 0 0 0-16.584-4.446 17.169 17.169 0 0 0-12.145 12.138Z",
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 137",
    d: "M224.854 138.824a21.503 21.503 0 0 1 1.09 29.227l-3.282-2.825a17.169 17.169 0 0 0-.87-23.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 138",
    d: "M225.943 168.051a21.503 21.503 0 0 1-29.064 3.27l2.572-3.484a17.169 17.169 0 0 0 23.21-2.612Z",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 139",
    d: "M196.877 171.326a21.503 21.503 0 0 1-7.996-22.87l4.184 1.122a17.169 17.169 0 0 0 6.39 18.261Z",
    opacity: 0.8
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Repeat Grid 9",
    transform: "translate(22 191)",
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1209"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1206"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1499",
    fill: "#fff",
    d: "M0 0h74v55H0z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1208",
    fill: "#9098a4",
    transform: "translate(-304 -1521)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1501",
    width: 20,
    height: 4,
    rx: 1,
    transform: "translate(314 1532)",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1207",
    transform: "translate(0 3)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 53,
    height: 4,
    rx: 1,
    transform: "translate(314 1537)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 53,
    height: 4,
    rx: 1,
    transform: "translate(314 1544)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 53,
    height: 4,
    rx: 1,
    transform: "translate(314 1551)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 53,
    height: 4,
    rx: 1,
    transform: "translate(314 1558)",
    opacity: 0.5
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1209"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1206"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1499",
    fill: "#fff",
    d: "M76 0h74v55H76z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1208",
    fill: "#9098a4",
    transform: "translate(-228 -1521)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1501",
    width: 20,
    height: 4,
    rx: 1,
    transform: "translate(314 1532)",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1207",
    transform: "translate(0 3)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 53,
    height: 4,
    rx: 1,
    transform: "translate(314 1537)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 53,
    height: 4,
    rx: 1,
    transform: "translate(314 1544)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 53,
    height: 4,
    rx: 1,
    transform: "translate(314 1551)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 53,
    height: 4,
    rx: 1,
    transform: "translate(314 1558)",
    opacity: 0.5
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1209"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1206"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1499",
    fill: "#fff",
    d: "M152 0h74v55h-74z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1208",
    fill: "#9098a4",
    transform: "translate(-152 -1521)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1501",
    width: 20,
    height: 4,
    rx: 1,
    transform: "translate(314 1532)",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1207",
    transform: "translate(0 3)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 53,
    height: 4,
    rx: 1,
    transform: "translate(314 1537)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 53,
    height: 4,
    rx: 1,
    transform: "translate(314 1544)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 53,
    height: 4,
    rx: 1,
    transform: "translate(314 1551)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 53,
    height: 4,
    rx: 1,
    transform: "translate(314 1558)",
    opacity: 0.5
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestmentCompare);
export default __webpack_public_path__ + "static/media/investment-compare.29fd3f8fe8a927ff85e7602434976ed6.svg";
export { ForwardRef as ReactComponent };